(function () {
  const SELECTOR = '.product-card-carousel';
  const OPTIONS = {
    cellAlign: 'center',
    contain: true,
    wrapAround: true,
    imagesLoaded: true,
    prevNextButtons: true,
    pageDots: true,
    lazyLoad: true,
  };

  let io = null;

  function initCard(cardElement) {
    if (typeof Flickity === 'undefined' || Flickity.data(cardElement)) return;

    new Flickity(cardElement, OPTIONS);

    cardElement.querySelectorAll('.flickity-button').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
      });
    });
  }

  // Karten zur Beobachtung anmelden — initialisiert wird erst beim Reinscrollen.
  function observeAll(root) {
    if (typeof Flickity === 'undefined') return;

    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (Flickity.data(el)) return;
      if (io) io.observe(el);
      else initCard(el); // Fallback ohne IntersectionObserver
    });
  }

  function start() {
    if (typeof IntersectionObserver !== 'undefined') {
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.unobserve(entry.target);
            initCard(entry.target);
          });
        },
        { rootMargin: '600px 0px' } // knapp vor dem Viewport vorbereiten
      );
    }

    observeAll();

    // Sortieren/Filtern ersetzt #ProductGridContainer.innerHTML. Dabei laufen
    // eingefuegte <script>-Tags nicht und alle Flickity-Instanzen sind weg.
    const grid = document.getElementById('ProductGridContainer');
    if (!grid) return;

    let scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        observeAll(grid);
      });
    }).observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    observeAll(event.target);
  });
})();